"use strict";
/* Generated from:
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class VPCEndpointConnectionNotification extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::EC2::VPCEndpointConnectionNotification', properties);
    }
}
exports.default = VPCEndpointConnectionNotification;
